import React from "react";
import { tabInfo } from "../../Routes/Analysis.js";
import KeyPoints from "./KeyPoints.js";
import RedFlags from "./RedFlags.js";
import OutOfPlace from "./OutOfPlace.js";
import Compare from "./Compare.js";

const ListComponent = ({type}) => {
    if (type === tabInfo[0].label) {
        return <KeyPoints/>;
    }
    if (type === tabInfo[1].label) {
        return <RedFlags/>;
    }
    if (type === tabInfo[2].label) {
        return <OutOfPlace/>;
    }
    if (type === tabInfo[3].label) {
        return <Compare/>;
    }
    return "";
}



export default ListComponent;